import React from "react";
import SortChevron from "../../_icons/SortChevron";

const EntityHead = ({
	title = "",
	sort = false,
	imgSrc = "",
	handleSortClick = () => {},
	sortedField = "",
	sortOrder = "",
	classes = ""
}) => {
	const sortedOrder =
		sortedField.toLowerCase() == title.toLowerCase() &&
		(sortOrder.toLowerCase() == "asc" || sortOrder.toLowerCase() == "desc")
			? sortOrder.toLowerCase()
			: "";
	return (
		<div
			onClick={() => handleSortClick(title)}
			className={`${title} entity-head ${classes} header ${sort ? "sort-col" : ""} font--regular base-font-14`}
		>
			{imgSrc && <img className="head-img" src={imgSrc} />}
			{title}
			{sort && (
				<div style={{ display: "flex", flexDirection: "column" }}>
					<SortChevron
						width={12}
						height={6}
						fill={sortedOrder == "asc" ? "#3B5FEB" : "#AAAAAA"}
						rotate={180}
					/>
					<SortChevron
						width={12}
						height={6}
						fill={sortedOrder == "desc" ? "#3B5FEB" : "#AAAAAA"}
						rotate={0}
					/>
				</div>
			)}
		</div>
	);
};
export default EntityHead;
